// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3dAyy","label":"Labeled_label__1M2BK","divider":"Labeled_divider__2Af93"};